import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form, Input, Select, Space } from 'antd';
import moment from 'moment';
import { QrReader } from 'react-qr-reader';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { QrcodeOutlined, EditOutlined } from '@ant-design/icons';
import CustomButton from '@/common/CustomButton';
import FormItem from '@/common/FormItem';
import Layout from '@/common/Layout';
import styles from '@/common/Layout/index.module.less';
import {
  getAllDispenseBooths,
  getBalance
} from '@/features/dispensing/redux/slice';
import { getLoggedInUser } from 'utilities/helpers';
import { history } from 'app/history';
import { createMiscellaneouslabels, getMiscellaneous } from '../redux/slice';

const { TextArea } = Input;
const CreateMiscellaneous = () => {
  const [form] = Form.useForm();

  const [openCam, setOpenCam] = useState(false);
  const [dispenseBooths, setDispenseBooths] = useState([]);
  const [ipAddress, setIpAddress] = useState('');
  const [portID, setPortID] = useState('');
  const [balancetype, setBalanceType] = useState('');
  const [tareWeight, setTareWeight] = useState('');
  const [netWeight, setNetWeight] = useState('');
  const [miscellaneousData, setMiscellaneousData] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const dispatch = useDispatch();
  const { user } = getLoggedInUser();
  const searchdata = useLocation().search;
  const params = new URLSearchParams(searchdata);

  useEffect(() => {
    handleGetDispenseBooths();
    params.get('id') ? handleGetMiscellaneousData() : '';
  }, []);

  const handleGetDispenseBooths = () => {
    dispatch(getAllDispenseBooths()).then((result) => {
      if (result?.payload?.success) {
        setDispenseBooths(result?.payload?.data);
      }
    });
  };

  const handleGetMiscellaneousData = () => {
    const payload = { id: params.get('id') };
    dispatch(getMiscellaneous(payload)).then((result) => {
      if (result?.payload?.success) {
        setMiscellaneousData(result?.payload?.data);
        setTareWeight(result?.payload?.data?.tare_wt);
        setNetWeight(result?.payload?.data?.net_wt);
        form.setFieldsValue({
          weighing_balance: result?.payload?.data?.weighing_bal,
          description: result?.payload?.data?.description
        });
      }
    });
  };
  const handleQrScan = async (scanData) => {
    if (scanData && scanData !== '') {
      console.log(scanData.text);
      setOpenCam(false);
    } else {
      console.log('asdasd');
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  const handleBalance = (e) => {
    let booth_details = dispenseBooths.filter((item) => item?.ip_address == e);
    setIpAddress(e);
    setPortID(booth_details?.[0]?.port);
    setBalanceType(booth_details?.[0]?.type);
  };

  const handleDispenseBooth = (weight_type) => {
    const payload = { ip: ipAddress, type: balancetype, port: portID };
    dispatch(getBalance(payload)).then((response) => {
      if (response?.payload?.success) {
        if (weight_type == 'tare_weight') {
          setTareWeight(response?.payload?.data);
        } else {
          setNetWeight(response?.payload?.data);
        }
      }
    });
  };

  const onFinish = (values) => {
    setIsSubmit(true);
    if (params.get('id')) {
      values['id'] = params.get('id');
    }
    values['net_wt'] = netWeight;
    values['tare_wt'] = tareWeight;
    // Round to 2 decimals: raw float addition (e.g. 0.20 + 5.69) yields
    // 5.890000000000001 — the source of the long-decimal gross weight.
    values['gross_wt'] = Number(
      (parseFloat(netWeight) + parseFloat(tareWeight)).toFixed(2)
    );
    values['weighing_bal'] = params.get('id')
      ? miscellaneousData?.weighing_bal
      : ipAddress;
    dispatch(createMiscellaneouslabels(values)).then((res) => {
      if (res.payload.success) {
        setIsSubmit(false);
        console.log(res?.payload?.pdf_url);
        // setIsSubmit(false);
        // setGenPdfs([...genPdfs, { pdf: res.payload.data }]);
        setTareWeight('');
        setNetWeight('');
        window.open(
          `${process.env.REACT_APP_STORAGE_URL}${res?.payload?.pdf_url
            .split('/')
            .pop()}`,
          '_blank'
        );
        history.push('/miscellaneousList');
        console.log('Success:', res.payload.data);
      } else {
        setIsSubmit(false);
      }
    });
  };

  // const weighing_balance_id = params.get('id')
  //   ? dispenseBooths?.filter((item) => item.ip_address === ipAddress)
  //   : ipAddress
  //   ? dispenseBooths?.filter((item) => item.ip_address === ipAddress)
  //   : '';

  return (
    <>
      <Layout sider={false}>
        <Card
          title="Miscellaneous Details"
          className={`${styles.cardStyles_approver}`}
          extra={
            params.get('id') ? (
              <CustomButton type="primary" onClick={() => setIsEdit(!isEdit)}>
                <EditOutlined />
              </CustomButton>
            ) : (
              ''
            )
          }
        >
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={24}>
              <Col xs={4} xl={2} span={2} md={2} sm={2}>
                <CustomButton className={styles.qrcode}>
                  <QrcodeOutlined onClick={() => setOpenCam(true)} />
                </CustomButton>
              </Col>
              <Col span={8}>
                {/* {params.get('id') || ipAddress ? (
                  <FormItem
                    label="Weighing Balance"
                    name="filled_weighing_balance"
                    rules={[
                      {
                        required: true,
                        message: 'Select Product Batch'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      disabled
                      // value={weighing_balance_id?.[0]?.balance_n}
                    />
                  </FormItem>
                ) : ( */}
                <FormItem
                  label="Weighing Balance"
                  name="weighing_balance"
                  rules={[
                    {
                      required: true,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Weighing Balance"
                    onChange={(e) => handleBalance(e)}
                    disabled={params.get('id')}
                  >
                    {dispenseBooths?.map((item, index) => {
                      return (
                        <option value={item?.ip_address} key={index}>
                          {item?.balance_name}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
                {/* )} */}
              </Col>
              <Col span={8}>
                <FormItem
                  label="Performed By"
                  rules={[
                    {
                      required: false,
                      message: 'Select Product name'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Input
                    placeholder=""
                    value={
                      params.get('id')
                        ? `${miscellaneousData?.User?.employee_id ?? ''} ( ${
                            miscellaneousData?.createdAt
                              ? moment(miscellaneousData.createdAt).format(
                                  'YYYY-MM-DD'
                                )
                              : ''
                          })`
                        : `${user?.employee} ( ${moment().format(
                            'YYYY-MM-DD'
                          )})`
                    }
                    disabled
                  />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <FormItem label="Container ID" className={styles.customLable}>
                  <Input
                    placeholder=""
                    value={miscellaneousData?.msc_containers || ''}
                    disabled
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Tare Weight"
                  rules={[
                    {
                      required: true,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <>
                    <Input
                      placeholder="Tare Weight"
                      onChange={(e) => setTareWeight(e.target.value)}
                      value={tareWeight}
                      disabled={params?.get('id') && !isEdit}
                    />
                    <CustomButton
                      style={{
                        color: '#c91761',
                        marginTop: '2px'
                      }}
                      size={'small'}
                      onClick={() => handleDispenseBooth('tare_weight')}
                    >
                      Read
                    </CustomButton>
                  </>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Net Weight"
                  rules={[
                    {
                      required: true,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <>
                    <Input
                      placeholder="Net Weight"
                      onChange={(e) => setNetWeight(e.target.value)}
                      value={netWeight || ''}
                      disabled={params?.get('id') && !isEdit}
                    />
                    <CustomButton
                      style={{
                        color: '#c91761',
                        marginTop: '2px'
                      }}
                      size={'small'}
                      onClick={() => handleDispenseBooth('net_weight')}
                    >
                      Read
                    </CustomButton>
                  </>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Gross Weight"
                  // name="gross_weight"
                  rules={[
                    {
                      required: false,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Input
                    placeholder="Gross Weight"
                    value={
                      Number(
                        (
                          parseFloat(tareWeight) + parseFloat(netWeight)
                        ).toFixed(2)
                      ) ||
                      miscellaneousData?.gross_wt ||
                      ''
                    }
                    disabled
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Description"
                  name="description"
                  rules={[
                    {
                      required: false,
                      message: 'Enter description'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <TextArea
                    rows={4}
                    placeholder="Please Enter Description"
                    disabled={params?.get('id') && !isEdit}
                  />
                </FormItem>
              </Col>
              {/* <Col span={4}>
                <FormItem className="text-center" style={{ marginTop: '28px' }}>
                  <CustomButton
                    className={styles.inwardButton}
                    htmlType="submit"
                    type="primary"
                    disabled={params?.get('id') && !isEdit}
                  >
                    Submit
                  </CustomButton>
                </FormItem>
              </Col> */}
            </Row>
            <FormItem className="text-center">
              <Space>
                <CustomButton
                  className={styles.inwardButton}
                  htmlType="submit"
                  type="primary"
                  disabled={(params?.get('id') && !isEdit) || isSubmit}
                  loading={isSubmit}
                >
                  {isSubmit ? 'Submitting...' : 'Submit & Print'}
                </CustomButton>
                <CustomButton
                  className={styles.inwardButton}
                  type="primary"
                  ghost
                  disabled={isSubmit}
                  onClick={() => history.push('/miscellaneousList')}
                >
                  Back
                </CustomButton>
              </Space>
            </FormItem>
            {openCam ? (
              <QrReader
                constraints={{
                  facingMode: 'environment'
                }}
                delay={300}
                onError={handleError}
                onResult={(result) => handleQrScan(result)}
                style={{
                  width: '100%',
                  height: 'auto'
                }}
              />
            ) : (
              ''
            )}
          </Form>
        </Card>
      </Layout>
    </>
  );
};
export default CreateMiscellaneous;
